import { render } from "./ContactPopup.vue?vue&type=template&id=3c44572a&scoped=true"
import script from "./ContactPopup.vue?vue&type=script&lang=js"
export * from "./ContactPopup.vue?vue&type=script&lang=js"

import "./ContactPopup.vue?vue&type=style&index=0&id=3c44572a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c44572a"]])

export default __exports__